import { download, get, send } from './api'

export interface IngestPhase {
  name: string
  state: string
  attempts: number
  last_error: string | null
  retryable: boolean
}

export interface IngestView {
  job_id: string
  state: string
  package_checksum: string
  package_key: string
  created_at: string
  finished_at: string | null
  phases: IngestPhase[]
}

export interface RetryResponse {
  job_id: string
  phase: string
  queued: boolean
  state: string
  attempts: number
  message: string
}

export interface UploadReceipt {
  receipt_id: string
  upload_id: string
  job_id: string
  package_name: string
  package_checksum: string
  objects: number
  bytes: number
  author: string
  issued_at: string
}

export function readIngest(jobId: string): Promise<IngestView> {
  return get<IngestView>(`/ingest/${jobId}`)
}

export function retryIngestPhase(jobId: string, phase: string, key: string): Promise<RetryResponse> {
  return send<RetryResponse>(`/ingest/${jobId}/phases/${phase}/retry`, {}, key)
}

export function readUploadReceipt(uploadId: string): Promise<UploadReceipt> {
  return get<UploadReceipt>(`/uploads/${uploadId}/receipt`)
}

export function downloadUploadReceipt(uploadId: string): Promise<Blob> {
  return download(`/uploads/${uploadId}/receipt/download`)
}
